/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {FC, useState, useEffect}  from 'react'
import { Field, ErrorMessage, FormikValues } from 'formik'
import Select from 'react-select'
import { useFormikContext } from 'formik';
import {listSimulations, listSubscriptionPlans, listAdditionalOptions, listSubscriptionLengths } from '../../../../../api/ordersApi'


const Step3_2: FC = () => {

  const { values, setFieldValue } = useFormikContext<FormikValues>();
  const [simulationsList, setSimulationsList] = useState<any[]>([]);
  const [subscriptionPlansList, setSubscriptionPlansList] = useState<any[]>([]);
  const [subscriptionLengthsList, setSubscriptionLengthsList] = useState<any[]>([]);
  const [selectedSimulation, setSelectedSimulation] = useState<string[]>([]);
  const [subscriptionPlan, setSubscriptionPlan] = useState<string>();
  const [subscriptionLength, setSubscriptionLength] = useState<number>();
  const [selectedPlan, setSelectedPlan] = useState<any>(null);
  const [selectedLength, setSelectedLength] = useState<any>(null);
  const [additionalOptions, setAdditionalOptions] = useState<any[]>([]);
  const [selectedAdditionalOptions, setSelectedAdditionalOptions] = useState<any[]>([]);
  const [selectedMultiplayerSimulation, setSelectedMultiplayerSimulation] = useState<string[]>([]);
  const [selectedPersonalizedSimulation, setSelectedPersonalizedSimulation] = useState<string>('');

  // Piani che includono l'elemento "Escape Room" nel menù multiplayer
  const ESCAPE_ROOM_PLANS = [
    'Solo Escape Room',
    'DiveVR + Escape Room',
    'Immersive + Escape Room',
    'Matrix + Escape Room',
  ];
  // Piani "Matrix" che includono TUTTE le simulazioni base (Pronto uso + Individuale)
  const MATRIX_PLANS = ['Matrix', 'Matrix + Personalizzato', 'Matrix + Escape Room'];

  useEffect(() => {
    const fetchSubscriptionPlans = async () => {
      try {
        const response = await listSubscriptionPlans();
        setSubscriptionPlansList(response);
  
        // Trova il piano di abbonamento corrispondente all'ID nel tuo set di dati
        const selectedPlan = response.find((pianoAbbonamento: any) => pianoAbbonamento.ID_Piano_abbonamento === values.ID_Piano_abbonamento);
        if (selectedPlan) {
          setSelectedPlan({ value: selectedPlan.ID_Piano_abbonamento, label: selectedPlan.Nome,  Num_max_simulazioni: selectedPlan.Num_max_simulazioni});
          // Allinea Piano_abbonamento all'ID (arriva precompilato come Nome da orderDetailsToEdit)
          setFieldValue('Piano_abbonamento', selectedPlan.ID_Piano_abbonamento);
          // Nome del piano usato dalla validazione (Piano_abbonamento resta l'ID per il backend)
          setFieldValue('Piano_abbonamento_nome', selectedPlan.Nome);
        }
      } catch (error) {
        console.error('Errore nel recupero dei piani d\'abbonamento:', error);
      }
    };
    fetchSubscriptionPlans();
  }, []);

  useEffect(() => {
    const fetchSubscriptionLength = async () => {
      try {
        const response = await listSubscriptionLengths();
        const filteredLenghts = response.filter((l:any) => ![13,14,15,16].includes(l.Durata))
                               .sort((a:any,b:any) => a.Durata - b.Durata);
        setSubscriptionLengthsList(filteredLenghts);
        const rawDur = Number(values.Lunghezza_abbonamento);            // lunghezza salvata nel DB
        const targetDur = [13,14,15,16].includes(rawDur) ? 12 : rawDur; // se è dal 13 al 16 → diventa 12
        const preset = filteredLenghts.find(
          (l:any) =>
            l.Durata === targetDur
        );
        if (preset) {
          setSelectedLength({value: preset.ID_Durata_abbonamento, label: preset.Durata});
          // assicura che il valore sia anche nello stato formik (edit)
          setFieldValue('Lunghezza_abbonamento', preset.Durata);
        }
      } catch (error) {
        console.error('Errore nel recupero delle lunghezze d\'abbonamento:', error);
      }
    };
    fetchSubscriptionLength();
  }, []);

  useEffect(() => {
    const fetchSimulazioni = async () => {
      try {
        const response2 = await listSimulations();
        setSimulationsList(response2);
        // Totale simulazioni base (Pronto uso + Individuale), usato dalla validazione dei piani "Matrix"
        const numBase = response2.filter(
          (s: any) => s.Tipologia === 'Pronto uso' && s.Modalita === 'Individuale'
        ).length;
        setFieldValue('Num_simulazioni_base', numBase);

        // Se values.ID_Simulazione è una stringa, la convertiamo in un array di numeri
        const ids = values.ID_Simulazioni ? values.ID_Simulazioni.split(",").map(Number) : [];

        // Ripartisco le simulazioni salvate tra i tre menù in base a Tipologia/Modalita
        const baseSims: any[] = [];
        const multiplayerSims: any[] = [];
        const personalizedSims: any[] = [];
        ids.forEach((id: number) => {
          const simulation = response2.find((s: any) => s.ID_Simulazione === id);
          if (!simulation) return;
          if (simulation.Tipologia === 'Personalizzato') {
            personalizedSims.push(simulation);
          } else if (simulation.Tipologia === 'Pronto uso' && simulation.Modalita === 'Cooperativo') {
            multiplayerSims.push(simulation);
          } else {
            baseSims.push(simulation);
          }
        });

        // Menù "Simulazioni scelte" (base): UI con i nomi, Formik con gli ID
        setSelectedSimulation(baseSims.map((s) => s.Nome));
        setFieldValue('Simulazioni_scelte', baseSims.map((s) => s.ID_Simulazione));

        // Menù "Simulazioni multiplayer"
        setSelectedMultiplayerSimulation(multiplayerSims.map((s) => s.Nome));
        setFieldValue('Simulazioni_multiplayer_scelte', multiplayerSims.map((s) => s.ID_Simulazione));

        // Menù "Simulazione personalizzata" (scelta singola)
        setSelectedPersonalizedSimulation(personalizedSims.length > 0 ? personalizedSims[0].Nome : '');
        setFieldValue('Simulazione_personalizzata_scelta', personalizedSims.length > 0 ? personalizedSims[0].ID_Simulazione : '');
      } catch (error) {
        console.error('Errore nel recupero delle simulazioni:', error);
      }
    };
    fetchSimulazioni();
  }, []);

  const handlePlanChange = (selectedOption: any) => {
    const plan = subscriptionPlansList.find(plan => plan.ID_Piano_abbonamento === selectedOption.value);
    if (plan) {
      setSelectedPlan({ 
        value: plan.ID_Piano_abbonamento, 
        label: plan.Nome,
        Num_max_simulazioni: plan.Num_max_simulazioni // Aggiungi questa linea
      });
      setSubscriptionPlan(plan.Nome);
      setFieldValue('Piano_abbonamento', plan.ID_Piano_abbonamento);
      // Nome del piano usato dalla validazione (Piano_abbonamento resta l'ID per il backend)
      setFieldValue('Piano_abbonamento_nome', plan.Nome);
    }

    if (!plan) return;

    // Reset dei tre menù al cambio piano
    setSelectedSimulation([]);
    setFieldValue('Simulazioni_scelte', []);
    setSelectedMultiplayerSimulation([]);
    setFieldValue('Simulazioni_multiplayer_scelte', []);
    setSelectedPersonalizedSimulation('');
    setFieldValue('Simulazione_personalizzata_scelta', '');

    // Preselezione Menù "Simulazioni scelte" = tutte le base (Pronto uso + Individuale) per i piani "Matrix …"
    if (MATRIX_PLANS.includes(plan.Nome)) {
      const tutteLeSimulazioniBase = simulationsList.filter(
        (simulation) => simulation.Tipologia === 'Pronto uso' && simulation.Modalita === 'Individuale'
      );
      setSelectedSimulation(tutteLeSimulazioniBase.map((s) => s.Nome));
      setFieldValue('Simulazioni_scelte', tutteLeSimulazioniBase.map((s) => s.ID_Simulazione));
    }

    // Preselezione Menù "Simulazioni multiplayer" = "Escape Room" per i piani "… Escape Room"
    if (ESCAPE_ROOM_PLANS.includes(plan.Nome)) {
      const escapeRoom = simulationsList.find((s) => s.Nome === 'Escape Room');
      if (escapeRoom) {
        setSelectedMultiplayerSimulation([escapeRoom.Nome]);
        setFieldValue('Simulazioni_multiplayer_scelte', [escapeRoom.ID_Simulazione]);
      }
    }
  };

  const handleLengthChange = (selectedOption: any) => {
    const lunghezza = subscriptionLengthsList.find(lunghezza => lunghezza.ID_Durata_abbonamento === selectedOption.value);
    setSelectedLength({ value: lunghezza.ID_Durata_abbonamento, label: lunghezza.Durata });
    const durataAsNumber = Number(lunghezza.Durata); // Conversione in numero
    setSubscriptionLength(durataAsNumber); // Imposta il valore come numero
    setFieldValue('Lunghezza_abbonamento', durataAsNumber); // Assicurati che questo sia il campo corretto e usato in Formik
  };

  const handleSimulationChange = (selectedOptions: any) => {
    if (selectedOptions && Array.isArray(selectedOptions)) {
      if (selectedPlan && selectedPlan.Num_max_simulazioni && selectedOptions.length <= selectedPlan.Num_max_simulazioni) {
        const selectedIds = selectedOptions.map((option: any) => {
          const simulation = simulationsList.find(simulation => simulation.Nome === option.value);
          return simulation ? simulation.ID_Simulazione : null;
        }).filter(id => id != null);
        setSelectedSimulation(selectedOptions.map(option => option.value)); // Mantieni la logica attuale per l'UI
        setFieldValue('Simulazioni_scelte', selectedIds);
      } else if (!selectedPlan) {
        alert('Per favore, seleziona un piano di abbonamento prima di scegliere le simulazioni.');
      } else if (selectedPlan && selectedPlan.Num_max_simulazioni) {
        alert(`Non puoi selezionare più di ${selectedPlan.Num_max_simulazioni} simulazioni.`);
      } else {
        alert('Si è verificato un errore. Riprova.');
      }
    } else {
      setSelectedSimulation([]);
      setFieldValue('Simulazioni_scelte', []);
    }
  };

  const handleMultiplayerSimulationChange = (selectedOptions: any) => {
    if (selectedOptions && Array.isArray(selectedOptions)) {
      const selectedIds = selectedOptions
        .map((option: any) => {
          const simulation = simulationsList.find((s) => s.Nome === option.value);
          return simulation ? simulation.ID_Simulazione : null;
        })
        .filter((id) => id != null);
      setSelectedMultiplayerSimulation(selectedOptions.map((option: any) => option.value));
      setFieldValue('Simulazioni_multiplayer_scelte', selectedIds);
    } else {
      setSelectedMultiplayerSimulation([]);
      setFieldValue('Simulazioni_multiplayer_scelte', []);
    }
  };

  const handlePersonalizedSimulationChange = (selectedOption: any) => {
    if (selectedOption) {
      const simulation = simulationsList.find((s) => s.Nome === selectedOption.value);
      setSelectedPersonalizedSimulation(selectedOption.value);
      setFieldValue('Simulazione_personalizzata_scelta', simulation ? simulation.ID_Simulazione : '');
    } else {
      setSelectedPersonalizedSimulation('');
      setFieldValue('Simulazione_personalizzata_scelta', '');
    }
  };

  useEffect(() => {
    const fetchAdditionalOptions = async () => {
      try {
        const response = await listAdditionalOptions();
        setAdditionalOptions(response);

        // Se values.ID_Simulazione è una stringa, la convertiamo in un array di numeri
        const ids = values.ID_Opzioni_aggiuntive ? values.ID_Opzioni_aggiuntive.split(",").map(Number) : [];
  
        // Trova i nomi delle simulazioni corrispondenti agli ID nel tuo set di dati
        const additionalOptionsNames = ids.map(
          (id: number) => response.find((additionalOption: any) => additionalOption.ID_Opzione_aggiuntiva === id)?.Nome
        );
        setSelectedAdditionalOptions(additionalOptionsNames);
      } catch (error) {
        console.error('Errore nel recupero delle opzioni aggiuntive:', error);
      }
    };
    fetchAdditionalOptions();
  }, []);
  
  const handleAdditionalOptionsChange = (selectedOptions: any) => {
    const selectedValues = selectedOptions.map((option: any) => option.value);
    setSelectedAdditionalOptions(selectedValues);
    setFieldValue('Opzioni_aggiuntive_scelte', selectedValues);
  };

  const selectedSimulationOptions = selectedSimulation.map(nome => ({
    value: nome,
    label: nome,
  }));

  // Menù "Simulazioni scelte": simulazioni pronte all'uso individuali
  const baseSimulationsOptions = simulationsList
    .filter((simulation) => simulation.Tipologia === 'Pronto uso' && simulation.Modalita === 'Individuale')
    .map((simulation) => ({ value: simulation.Nome, label: simulation.Nome }));

  // Menù "Simulazioni multiplayer": simulazioni pronte all'uso cooperative
  const multiplayerSimulationsOptions = simulationsList
    .filter((simulation) => simulation.Tipologia === 'Pronto uso' && simulation.Modalita === 'Cooperativo')
    .map((simulation) => ({ value: simulation.Nome, label: simulation.Nome }));

  // Menù "Simulazione personalizzata": simulazioni personalizzate
  const personalizedSimulationsOptions = simulationsList
    .filter((simulation) => simulation.Tipologia === 'Personalizzato')
    .map((simulation) => ({ value: simulation.Nome, label: simulation.Nome }));

  return (
    <div className='w-100'>
      <div className='pb-10 pb-lg-15'>
        <h2 className='fw-bolder text-dark'>Servizi</h2>
        <div className='text-gray-400 fw-bold fs-6'>Inserisci i dati</div>
      </div>

      {/*Inizio piano d'abbonamento*/}
      <div className='fv-row mb-10'>
        <label className='d-flex align-items-center form-label mb-5 required'>
          Piano d'abbonamento
        </label>
        
        <div className='row mb-2' data-kt-buttons='true'>
        <Select
          className='form-select-solid form-select-lg fw-bold'
          value={selectedPlan}
          options={subscriptionPlansList.map((pianoAbbonamento) => ({ value: pianoAbbonamento.ID_Piano_abbonamento, label: pianoAbbonamento.Nome }))}
          isSearchable={false}
          onChange={handlePlanChange}
          placeholder= "Seleziona un piano d'abbonamento"
        />
        </div>

        <div className='form-text'>
          
        </div>
      </div>
      {/*Fine piano d'abbonamento*/}

      {/*<div className='fv-row mb-10'>
        <label htmlFor='Lunghezza_abbonamento' className='form-label required'>
          Lunghezza abbonamento (mesi)
        </label>
        <Field
          type='number'
          id='Lunghezza_abbonamento'
          name='Lunghezza_abbonamento'
          className='form-control form-control-lg form-control-solid'
        />
        
          <div className='text-danger mt-2'>
            <ErrorMessage name='Lunghezza_abbonamento' />
          </div>  
      </div>*/}

      {/*Inizio lunghezza abbonamento*/}
      <div className='fv-row mb-10'>
        <label htmlFor='Lunghezza_abbonamento' className='form-label required'>
          Lunghezza abbonamento (mesi)
        </label>

        <div className='row mb-2' data-kt-buttons='true'>
          <Select
            className='form-select-solid form-select-lg fw-bold'
            value={selectedLength}
            options={subscriptionLengthsList.map((lunghezzaAbbonamento) => ({ value: lunghezzaAbbonamento.ID_Durata_abbonamento, label: lunghezzaAbbonamento.Durata }))}
            isSearchable={false}
            onChange={handleLengthChange}
            placeholder= "Seleziona una lunghezza d'abbonamento"
          />
        </div>
        
          <div className='text-danger mt-2'>
            <ErrorMessage name='Lunghezza_abbonamento' />
          </div>  
      </div>
      {/*Fine lunghezza abbonamento*/}

      {/*Inizio simulazioni scelte*/}
      <div className='mb-10 fv-row'>
        <label className='d-flex align-items-center form-label mb-5 required'>
          Simulazioni scelte
        </label>

        <Select
          isMulti
          className='form-select-solid form-select-lg fw-bold'
          value={selectedSimulationOptions}
          placeholder="Scegli simulazioni"
          options={baseSimulationsOptions}
          onChange={handleSimulationChange}
        />

        <div className='form-text'>

        </div>
      </div>
      {/*Fine simulazioni scelte*/}

      {/*Inizio simulazioni multiplayer*/}
      <div className='mb-10 fv-row'>
        <label className='d-flex align-items-center form-label mb-5'>
          Simulazioni multiplayer
        </label>

        <Select
          isMulti
          className='form-select-solid form-select-lg fw-bold'
          value={selectedMultiplayerSimulation.map((nome) => ({ value: nome, label: nome }))}
          placeholder="Scegli simulazioni multiplayer"
          options={multiplayerSimulationsOptions}
          onChange={handleMultiplayerSimulationChange}
        />

        <div className='text-danger mt-2'>
          <ErrorMessage name='Simulazioni_multiplayer_scelte' />
        </div>
      </div>
      {/*Fine simulazioni multiplayer*/}

      {/*Inizio simulazione personalizzata*/}
      <div className='mb-10 fv-row'>
        <label className='d-flex align-items-center form-label mb-5'>
          Simulazione personalizzata
        </label>

        <Select
          isClearable
          className='form-select-solid form-select-lg fw-bold'
          value={
            selectedPersonalizedSimulation
              ? { value: selectedPersonalizedSimulation, label: selectedPersonalizedSimulation }
              : null
          }
          placeholder="Scegli una simulazione personalizzata"
          options={personalizedSimulationsOptions}
          onChange={handlePersonalizedSimulationChange}
        />

        <div className='text-danger mt-2'>
          <ErrorMessage name='Simulazione_personalizzata_scelta' />
        </div>
      </div>
      {/*Fine simulazione personalizzata*/}

      {/* Inizio opzioni aggiuntive */}
      <div className='mb-10 fv-row'>
        <label className='d-flex align-items-center form-label mb-5'>
          Opzioni aggiuntive
        </label>
        
        <Select
          isMulti
          className='form-select-solid form-select-lg fw-bold'
          value={selectedAdditionalOptions.map((nome) => ({ value: nome, label: nome }))}
          placeholder="Scegli opzioni aggiuntive"
          options={additionalOptions.map((option) => ({ value: option.Nome, label: option.Nome }))}
          onChange={handleAdditionalOptionsChange}
        />

      </div>
      {/* Fine opzioni aggiuntive */}

      {/*Inizio importo effettivo (solo licenze)*/}
      <div className='fv-row mb-10'>
        <label htmlFor='Importo_effettivo' className='form-label required'>
          Importo effettivo (solo licenze)
        </label>
        <Field
          type='number'
          id='Importo_effettivo'
          name='Importo_effettivo'
          className='form-control form-control-lg form-control-solid'
        />
        
          <div className='text-danger mt-2'>
            <ErrorMessage name='Importo_effettivo' />
          </div>  
      </div>
      {/*Fine importo effettivo*/}

      {/*Inizio note aggiuntive*/}
      <div className='fv-row mb-10'>
        <label htmlFor='Note_aggiuntive' className='form-label'>
          Note aggiuntive
        </label>
        <Field
          as='textarea'
          id='Note_aggiuntive'
          name='Note_aggiuntive'
          className='form-control form-control-lg form-control-solid'
        />
        
          <div className='text-danger mt-2'>
            <ErrorMessage name='Note_aggiuntive' />
          </div>  
      </div>
      {/*Fine note aggiuntive*/}
    </div>
  )
}

export {Step3_2}